/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: 66d514252f27
 */

import * as z from "zod";

/**
 * The asset unrelation request.
 */
export type UnrelateAssetsByAssetIdRequest = {
  assets_to_unrelate: Array<string>;
};

export const UnrelateAssetsByAssetIdRequest$zodSchema: z.ZodType<
  UnrelateAssetsByAssetIdRequest
> = z.object({
  assets_to_unrelate: z.array(z.string()).describe(
    "Unrelates the asset from all the assets specified in this array of assets, specified by their asset IDs.",
  ),
}).describe("The asset unrelation request.");
